export default {
  LOAD_CURRENT_ENVIRONMENT (state, payload) {
    state.currentEnvironment = payload
  },
  LOAD_INSTITUTION (state, payload) {
    state.institution = payload
  },
  LOAD_PACKAGES (state, payload) {
    state.packages = payload
  },
  LOAD_ENABLED_FEATURES (state, payload) {
    state.enabledFeatures = payload
  },
  LOAD_PLANNING_STREAM (state, payload) {
    state.stream = payload
  },
  LOAD_COURSE (state, payload) {
    state.course = payload
  },
  LOAD_COURSE_TOPICS (state, payload) {
    if (payload.isState) {
      state.topics = []
    }
    state.topics = payload.data
  },
  LOAD_COURSE_LINEAR_TOPICS (state, payload) {
    if (payload.isState) {
      state.linearTopics = []
    }
    state.linearTopics = payload.data
  },
  LOAD_COURSE_TOPICS_MAP (state, payload) {
    if (payload.isState) {
      state.topicsMap = {}
    }
    state.topicsMap = payload.data
  },
  LOAD_COURSE_COMPETENCIES (state, payload) {
    state.competencies = payload
  },
  LOAD_ENTITY_UUID (state, payload) {
    state.entityUuid = payload
  },
  LOAD_ENTITY_DETAIL (state, payload) {
    state.entity = payload
    if (state.entity.objectType === 'LearningContent' && state.entity.fileType === 'video') {
      var uri = state.entity.uri
      var yt = ''
      if (uri.indexOf('v=') > 0 || uri.indexOf('embed') > 0) {
        yt = uri.substring(30)
      } else {
        yt = uri.substring(16)
      }
      state.entity.yt = yt
    }
    var iframeUrl = ''
    if (state.entity.objectType === 'LearningContent') {
      if (state.entity.fileType === 'pdf' || state.entity.fileType === 'doc' || state.entity.fileType === 'docx' || state.entity.fileType === 'pptx' || state.entity.fileType === 'ppt') {
        iframeUrl = 'https://drive.google.com/viewerng/viewer?url=' + state.entity.uri + '&embedded=true'
      } else {
        iframeUrl = state.entity.uri
      }
      state.entity.iframeUrl = iframeUrl
    }
  },
  LOAD_ENTITY_COMPETENCY (state, payload) {
    state.entityCompetency = payload
  },
  LOAD_NEXT_ENTITY_DETAIL (state, payload) {
    if (payload.uuid === '') {
      var next = {
        'title': 'Congratulations!',
        'description': 'You have successfully attempted all the competencies',
        'fileType': 'assessment'
      }
      state.nextEntity = next
    } else {
      state.nextEntity = payload
      state.continueLearning = payload
    }
  },
  LOAD_LEARNER_DASHBOARD_STATE (state, payload) {
      state.learnerDashboardState = payload
  },
  LOAD_LEARNER_DASHBOARD_COMPONENTS (state, payload) {
      state.learnerDashboardComponents = payload
  },
  LOAD_LEARNER_ENROLLMENT_DATA (state, payload) {
      state.learnerEnrollmentData = payload
  },
  LOAD_ALL_CHANNELS (state, payload) {
    state.channels = payload
  },
  LOAD_CHANNEL_UNREAD_COUNT (state, payload) {
    state.channelUnreadCount[payload.channelId] = payload.unread
    let count = 0
    for (const key in state.channelUnreadCount) {
      count += state.channelUnreadCount[key]
    }
    state.unreadCountState = count
  },
  LOAD_CUSTOM_BAD_WORDS (state, payload) {
    state.customBadWords = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/vuex/mutations.js